import { render, staticRenderFns } from "./listDownload.vue?vue&type=template&id=a2ffe22c&scoped=true"
import script from "./listDownload.vue?vue&type=script&lang=js"
export * from "./listDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ffe22c",
  null
  
)

export default component.exports